import { LocaleLoaders } from './locales.js';

async function getDateLocaleFromLocale(locale) {
  const {
    default: dateLocale
  } = await loadLocale(locale);
  return dateLocale;
}
const loadLocale = language => {
  if (LocaleLoaders[language]) {
    return LocaleLoaders[language]();
  }
  const primaryLang = language.split('-')[0];
  if (LocaleLoaders[primaryLang]) {
    return LocaleLoaders[primaryLang]();
  }
  console.warn(`Giger - DatePicker: Locale "${language}" is not supported`);
  return LocaleLoaders['en-GB']();
};
const DATE_PICKER_INPUT_LABEL = 'date-picker-input';
const isElementWithLabel = (element, label) => {
  if (!element) return false;
  return element.getAttribute('aria-label') === label;
};
const isDatePickerInput = element => {
  return isElementWithLabel(element, DATE_PICKER_INPUT_LABEL);
};
const isClearButton = (element, label) => {
  if (!element) return false;
  return isElementWithLabel(element, label);
};

export { DATE_PICKER_INPUT_LABEL, getDateLocaleFromLocale, isClearButton, isDatePickerInput, isElementWithLabel };
//# sourceMappingURL=utils.js.map
